import React, { useCallback, useState } from 'react';
import {
  IonText,
  IonCard,
  IonCardTitle,
  IonRow,
  IonButton,
  IonLabel,
  IonAlert,
  IonCol,
} from '@ionic/react';
import {
  CartItemType,
  ICartMenusSelection,
  ICartProductSelection,
} from '../../../domains/shop/ShopTypes';
import styles from './MenuSelectionItem.module.scss';

interface IProps {
  menuSelection: ICartMenusSelection;
  removeSelection: (cartItemType: CartItemType, id: number) => any;
  style?: any;
}

const QuantityAndAmount: React.FC<IProps> = (props) => {
  const {
    menuSelection: { id, amount },
    removeSelection,
  } = props;

  const [showRemoveAlert, setShowRemoveAlert] = useState(false);

  const decrement = useCallback(() => {
    setShowRemoveAlert(true);
  }, []);

  const remove = useCallback(() => {
    removeSelection('menu', id);
  }, [id, removeSelection]);

  return (
    <IonRow class="ion-align-items-center ion-justify-content-between">
      <IonRow class="ion-align-items-center">
        <IonButton color="light" onClick={decrement}>
          <IonText>
            <p>delete</p>
          </IonText>
        </IonButton>
        {/* 
        <IonLabel className="ion-padding">
          <IonText>
            <h2>{productQuantity}</h2>
          </IonText>
        </IonLabel>

        <IonButton color="light" onClick={increment}>
          <IonText>
            <p>+</p>
          </IonText>
        </IonButton> */}
      </IonRow>

      <IonText>
        <h2>{amount}$</h2>
      </IonText>

      <IonAlert
        isOpen={showRemoveAlert}
        onDidDismiss={() => setShowRemoveAlert(false)}
        cssClass="my-custom-class"
        header={'Caution'}
        message={'Are you sure to remove this item?'}
        buttons={[
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => setShowRemoveAlert(false),
          },
          {
            text: 'Remove',
            cssClass: 'secondary',
            handler: remove,
          },
        ]}
      />
    </IonRow>
  );
};

const MenuSelectionItem: React.FC<IProps> = (props: IProps) => {
  const {
    menuSelection: { id, menu },
  } = props;

  return (
    <IonCard key={id}>
      <div className={styles.cardHeader}>
        <div
          style={{
            // backgroundImage: `url(${environment.API_ENDPOINT}${product.picture?.url})`,
            backgroundImage: `url(${menu.picture?.url})`,
          }}
          className={styles.imgBg}
        />
        {/* <img src={`${environment.API_ENDPOINT}${product.picture?.url}`} alt="" /> */}
        <IonCol className="ion-padding">
          <IonCardTitle className={styles.cardTitle}>{menu.name}</IonCardTitle>
          <br />
          <QuantityAndAmount {...props} />
        </IonCol>
      </div>
    </IonCard>
  );
};

export default MenuSelectionItem;
